{
  "contractVersion": 1,
  "generatedAt": "2026-07-15T18:00:00.000Z",
  "season": { "id": "season-2026-q1", "name": "Season 1", "dayNumber": 42 },
  "sides": {
    "beornings": { "totalPoints": 8000, "sharePct": 80.0 },
    "lothwen": { "totalPoints": 2000, "sharePct": 20.0 }
  },
  "world": { "treesChoppedTotal": 80, "treesPlantedTotal": 20 },
  "events": [
    { "id": 78, "type": "tree_felled", "side": "beornings", "at": "2026-07-14" },
    { "id": 79, "type": "tree_planted", "side": "lothwen", "at": "2026-07-14" },
    { "id": 80, "type": "tree_felled", "side": "beornings", "at": "2026-07-15" }
  ]
}
